import { v4 as uuid } from 'uuid';
import {
  netsStatement,
  celticsCity,
  philadelphiaCity,
  dallasCity,
  milwaukeeCity,
  brooklynCity,
  orleansCity,
  lakersCity,
  clippersCity,
  lakersIcon,
  mavericksIcon,
  clippersIcon,
  netsIcon,
  bucksIcon,
} from '../../assets';

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    _id: 2,
    title: 'Boston Celtics City Edition',
    image: celticsCity,
    price: '3000',
    categoryName: 'City Edition',
    itemDescription: 'Nike Dri-FIT NBA Swingman Jersey',
    inStock: true,
    fastDelivery: true,
    rating: 3,
  },
  {
    _id: 3,
    title: 'Philadelphia City Edition',
    image: philadelphiaCity,
    price: '2000',
    categoryName: 'City Edition',
    itemDescription: 'Nike Dri-FIT NBA Swingman Jersey',
    inStock: true,
    fastDelivery: true,
    rating: 4,
  },
  {
    _id: 4,
    title: 'Dallas City Edition',
    image: dallasCity,
    price: '2500',
    categoryName: 'City Edition',
    itemDescription: 'Nike Dri-FIT NBA Swingman Jersey',
    inStock: true,
    fastDelivery: true,
    rating: 5,
  },
  {
    _id: 5,
    title: 'Bucks City Edition',
    image: milwaukeeCity,
    price: '2800',
    categoryName: 'City Edition',
    itemDescription: 'Nike Dri-FIT NBA Swingman Jersey',
    inStock: true,
    fastDelivery: true,
    rating: 3,
  },
  {
    _id: 6,
    title: 'Nets City Edition',
    image: brooklynCity,
    price: '3800',
    categoryName: 'City Edition',
    itemDescription: 'Nike Dri-FIT NBA Swingman Jersey',
    inStock: true,
    fastDelivery: true,
    rating: 2,
  },
  {
    _id: 7,
    title: 'Pelicans City Edition',
    image: orleansCity,
    price: '4000',
    categoryName: 'City Edition',
    itemDescription: 'Nike Dri-FIT NBA Swingman Jersey',
    inStock: true,
    fastDelivery: false,
    rating: 1,
  },
  {
    _id: 8,
    title: 'Lakers City Edition',
    image: lakersCity,
    price: '3200',
    categoryName: 'City Edition',
    itemDescription: 'Nike Dri-FIT NBA Swingman Jersey',
    inStock: true,
    fastDelivery: true,
    rating: 4,
  },
  {
    _id: 9,
    title: 'Clippers City Edition',
    image: clippersCity,
    price: '2300',
    categoryName: 'City Edition',
    itemDescription: 'Nike Dri-FIT NBA Swingman Jersey',
    inStock: true,
    fastDelivery: false,
    rating: 5,
  },
  {
    _id: 10,
    title: 'Lakers Icon Edition 2020',
    image: lakersIcon,
    price: '2600',
    categoryName: 'Icon Edition',
    itemDescription: 'Nike NBA Swingman Jersey',
    inStock: false,
    fastDelivery: false,
    rating: 4,
  },
  {
    _id: 11,
    title: 'Mavericks Icon Edition 2020',
    image: mavericksIcon,
    price: '1000',
    categoryName: 'Icon Edition',
    itemDescription: 'Nike NBA Swingman Jersey',
    inStock: false,
    fastDelivery: false,
    rating: 3,
  },
  {
    _id: 12,
    title: 'Clippers Icon Edition 2020',
    image: clippersIcon,
    price: '1900',
    categoryName: 'Icon Edition',
    itemDescription: 'Nike NBA Swingman Jersey',
    inStock: false,
    fastDelivery: false,
    rating: 4,
  },
  {
    _id: 13,
    title: 'Nets Icon Edition 2020',
    image: netsIcon,
    price: '2900',
    categoryName: 'Icon Edition',
    itemDescription: 'Nike NBA Swingman Jersey',
    inStock: true,
    fastDelivery: false,
    rating: 2,
  },
  {
    _id: 14,
    title: 'Bucks Icon Edition 2020',
    image: bucksIcon,
    price: '4500',
    categoryName: 'Icon Edition',
    itemDescription: 'Nike NBA Swingman Jersey',
    inStock: false,
    fastDelivery: true,
    rating: 4,
  },
];
